import { Page } from '../../layout/Page.tsx'

const OrganizationOverview = () => {
	return (
		<Page title="Organization" breadcrumbs="Organization">
			<div className="flex flex-col justify-center items-center">
				<div className="w-full">This page is under construction</div>
			</div>
			{/*<Org />*/}
		</Page>
	)
}

export default OrganizationOverview
